import React from "react";
import { useNavigate } from "react-router-dom";

import { useAuthSession } from "@/features/auth";
import { MARKETING_BOOK_DEMO_URL } from "@/features/commandDeck/config/commandDeckMvp";

const chromeBtnClass =
  "inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-semibold text-slate-900 dark:text-white bg-white/80 dark:bg-white/[0.10] border border-black/10 dark:border-white/10 hover:bg-white dark:hover:bg-white/[0.14] shadow-[0_8px_24px_-12px_rgba(15,23,42,.32)] transition";

const chromeBtnGhostClass =
  "inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-medium text-slate-800/90 dark:text-white/85 border border-black/10 dark:border-white/10 hover:bg-black/[0.04] dark:hover:bg-white/[0.08] transition";

export default function NavAuthCta(): JSX.Element {
  const { status, signOut } = useAuthSession();
  const navigate = useNavigate();

  if (status === "loading") {
    return (
      <span
        className="inline-flex min-w-[8rem] items-center rounded-xl px-3.5 py-2 text-sm text-slate-500/80 dark:text-white/50"
        role="status"
        aria-busy="true"
        aria-live="polite"
      >
        Checking access…
      </span>
    );
  }

  if (status === "authenticated") {
    return (
      <div className="inline-flex items-center gap-2">
        <button type="button" onClick={() => navigate("/account")} className={chromeBtnClass}>
          Account
        </button>
        <button
          type="button"
          onClick={() => {
            void signOut();
          }}
          className="inline-flex items-center rounded-xl px-3 py-2 text-xs font-medium text-white/80 bg-white/10 border border-white/10 hover:bg-white/15 hover:text-white transition"
          title="Sign out"
        >
          Sign out
        </button>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2" aria-label="Controlled access">
      <a
        href={MARKETING_BOOK_DEMO_URL}
        target="_blank"
        rel="noreferrer"
        className={chromeBtnClass}
      >
        Request Access
      </a>
      <a href={MARKETING_BOOK_DEMO_URL} target="_blank" rel="noreferrer" className={chromeBtnGhostClass}>
        Book Demo
      </a>
    </div>
  );
}
